export default __webpack_public_path__ + "static/media/scratchwin.e53c882e.png";